import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
export const JoinPageHeader = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <header className="relative flex h-140 flex-col justify-center gap-10 bg-[url('/assets/pngs/policy-info-bg.png')] bg-contain bg-right bg-no-repeat px-20">{children}</header>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};